import { render } from "./TapsPlatform.vue?vue&type=template&id=45b98cbe&scoped=true"
import script from "./TapsPlatform.vue?vue&type=script&lang=js"
export * from "./TapsPlatform.vue?vue&type=script&lang=js"

import "./TapsPlatform.vue?vue&type=style&index=0&id=45b98cbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b98cbe"]])

export default __exports__